import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { z } from 'zod';

/**
 * Shared contract schema for a stored phone number. Requires a fully-qualified
 * international number with an explicit country code and transforms it to its
 * canonical ITU-T E.164 form (`+49…`). There is no default region: callers —
 * our own frontend and any other API consumer — must send a complete number,
 * so a bare national number (without `+<country code>`) is rejected. Rejecting
 * at the contract boundary means an invalid number cannot reach the domain via
 * any caller.
 *
 * Applied only to contact write bodies; response/read schemas stay loose so a
 * legacy stored value never hard-errors on read. Lead capture is intentionally
 * exempt — it accepts anything.
 */
export const PhoneNumberSchema = z
  .string()
  .trim()
  .refine((value) => isValidPhoneNumber(value), {
    message: 'phone must be a valid phone number including country code (E.164)',
  })
  .transform((value) => parsePhoneNumberFromString(value)!.number);
